import { CollectionActionTypes } from '../constants/cp-action-types';
import { COLLECTION_STAGE, COLLECTION_STATUS, getSanitizedIdFromTitle } from '../../utils/constants/content-production';

export interface CollectionReducerInterface {
    dashBoardData: [];
    surface: string;
    locale: string;
    app: string;
    status: string;
    stage: string;
    sortBy: string;
    sortOrder: string;
    aem_id: string;
    selectedCollections: [];
    selectedPLSInsideCL: [];
    fullCL: {};
    saveFlagCL: boolean;
    addPlaylistsToCLFlag: boolean;
    searchStr: string;
    searchFrom: number;
    searchSize: number;
    clDetailViewSections: [];
}

const intialState = {
    dashBoardData: [],
    surface: 'all',
    locale: 'en_US',
    app: 'all',
    status: 'all',
    stage: 'all',
    sortBy: '',
    sortOrder: '',
    aem_id: '',
    selectedCollections: [],
    selectedPLSInsideCL: [],
    fullCL: {},
    saveFlagCL: false,
    addPlaylistsToCLFlag: false,
    searchStr: '',
    searchFrom: 0,
    searchSize: 12,
    clDetailViewSections: [],
} as CollectionReducerInterface;

export const collectionDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case CollectionActionTypes.UPDATE_CL_DASHBOARD_DATA:
            return { ...state, dashBoardData: [...payload] };
        case CollectionActionTypes.UPDATE_CL_SURFACE:
            return { ...state, surface: payload };
        case CollectionActionTypes.UPDATE_CL_LOCALE:
            return { ...state, locale: payload };
        case CollectionActionTypes.UPDATE_CL_APP:
            return { ...state, app: payload };
        case CollectionActionTypes.UPDATE_CL_STATUS: {
            let stage = state.stage;
            switch (payload) {
                case COLLECTION_STATUS.LIVE:
                    stage = COLLECTION_STAGE.NONE;
                    break;
                case COLLECTION_STATUS.ALL:
                    stage = COLLECTION_STAGE.ALL;
                    break;
                case COLLECTION_STATUS.DRAFT:
                    stage = COLLECTION_STAGE.ALL;
                    break;
                default:
                    stage;
            }
            return {
                ...state,
                status: payload,
                stage,
            };
        }
        case CollectionActionTypes.UPDATE_CL_STAGE:
            return { ...state, stage: payload };
        case CollectionActionTypes.UPDATE_CL_SORT_ORDER:
            return { ...state, sortOrder: payload };
        case CollectionActionTypes.UPDATE_CL_SORT_BY:
            return { ...state, sortBy: payload };
        case CollectionActionTypes.UPDATE_CL_AEMID:
            return { ...state, aem_id: payload };
        case CollectionActionTypes.UPDATE_CL_SELECTED_CLS:
            return { ...state, selectedCollections: [...payload] };
        case CollectionActionTypes.UPDATE_FULL_CL:
            return { ...state, fullCL: { ...payload } };
        case CollectionActionTypes.UPDATE_CL_DETAIL_VIEW_SECTIONS:
            return { ...state, clDetailViewSections: [...payload] };
        case CollectionActionTypes.UPDATE_CL_SAVE_FLAG:
            return { ...state, saveFlagCL: payload };
        case CollectionActionTypes.UPDATE_ADD_PLAYLIST_TO_CL_FLAG:
            return { ...state, addPlaylistsToCLFlag: payload };
        case CollectionActionTypes.UPDATE_CL_SEARCH_STR:
            return { ...state, searchStr: payload };
        case CollectionActionTypes.UPDATE_CL_SEARCH_FROM:
            return { ...state, searchFrom: payload };
        case CollectionActionTypes.UPDATE_CL_SEARCH_SIZE:
            return { ...state, searchSize: payload };
        case CollectionActionTypes.UPDATE_CL_SELECTED_PLS:
            return { ...state, SelectedPLSInsideCL: [...payload] };
        case CollectionActionTypes.UPDATE_CL_SECTION_NAME: {
            const currentClDetailViewSections: any = JSON.parse(JSON.stringify(state.clDetailViewSections));
            const objIndex = currentClDetailViewSections.findIndex((obj) => obj['id'] == payload.rec['id']);
            currentClDetailViewSections[objIndex].title = payload.newName;
            return { ...state, clDetailViewSections: [...currentClDetailViewSections] };
        }
        case CollectionActionTypes.UPDATE_CL_NEW_SECTION: {
            let currentClDetailViewSections: any = JSON.parse(JSON.stringify(state.clDetailViewSections));
            const rec = {};
            rec['id'] = getSanitizedIdFromTitle(payload);
            rec['title'] = payload;
            rec['items'] = [];
            currentClDetailViewSections = [...currentClDetailViewSections, rec];
            return { ...state, clDetailViewSections: [...currentClDetailViewSections] };
        }
        case CollectionActionTypes.ADD_NEW_PL: {
            const newEntry = {
                id: payload.aem_id,
                type: 'playlist',
                _metadata: payload,
            };
            const currentCLViewPlaylists: any = JSON.parse(JSON.stringify(state.clDetailViewSections));
            currentCLViewPlaylists[currentCLViewPlaylists.length - 1]['items'] = [
                ...currentCLViewPlaylists[currentCLViewPlaylists.length - 1]['items'],
                newEntry,
            ];
            return { ...state, clDetailViewSections: [...currentCLViewPlaylists] };
        }
        case CollectionActionTypes.RESET_ALL_FILTERS_CL:
            return {
                ...state,
                surface: 'all',
                locale: 'en_US',
                app: 'all',
                status: 'all',
                stage: 'all',
                sortBy: '',
                sortOrder: '',
                selectedCollections: [],
                fullCL: {},
                clDetailViewSections: [],
                saveFlagCL: false,
                addPlaylistsToCLFlag: false,
                searchFrom: 0,
            };
        default:
            return state;
    }
};
